module.exports = __webpack_public_path__ + "static/payal_video-e344aa4c3e9a6a85765f9b495b6f630b.jpg";